module.exports = __webpack_public_path__ + "static/media/vova-2.ba8198bc.png";